import React from "react"

import Layout from "../layouts/layout"
import SEO from "../components/seo"
import { css } from "styled-components"
import { Heading } from "../components"
import Projects from "../components/Projects"

const ProjectPage = () => {
  return (
    <>
      <Layout>
        <SEO title="Projects" />
        <div
          css={css`
            position: relative;
            max-width: 960px;
            margin: auto;
            padding: 40px 0px;
          `}
        >
          <div>
            <Heading as="h1" variant="h1" level={1}>
              Projects
            </Heading>
            <Projects />
          </div>
        </div>
      </Layout>
    </>
  )
}

export default ProjectPage
